module.exports = __webpack_public_path__ + "img/smoke2.735e54bf.png";